import { render, staticRenderFns } from "./TaskThreadOverview.vue?vue&type=template&id=05c88ae9&"
import script from "./TaskThreadOverview.vue?vue&type=script&lang=ts&"
export * from "./TaskThreadOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports